import { useEffect, useRef } from 'react'
import { gsap, prefersReducedMotion } from 'lib/motion'

/**
 * Fade-and-rise a list row when it scrolls into view (once). Attach the
 * returned ref to the row's root element.
 */
export function useRowReveal<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null)

  useEffect(() => {
    const el = ref.current
    if (!el || prefersReducedMotion()) return undefined
    const tween = gsap.from(el, {
      opacity: 0,
      y: 16,
      duration: 0.4,
      ease: 'power2.out',
      clearProps: 'all',
      scrollTrigger: { trigger: el, start: 'top 95%', once: true },
    })
    return () => {
      tween.scrollTrigger?.kill()
      tween.kill()
    }
  }, [])

  return ref
}

export default useRowReveal
